import { ActivatedRouteSnapshot, Resolve, RouterStateSnapshot } from '@angular/router';
import { LiabilityDataModel } from '../models/liability-data.model';
import { Observable } from 'rxjs';
import { PaymentService } from '../services/payment.service';
import { Injectable } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class PaymentResolver implements Resolve<LiabilityDataModel> {
  constructor(private paymentService: PaymentService) {}

  resolve(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<LiabilityDataModel> | Promise<LiabilityDataModel> | LiabilityDataModel {
    return this.paymentService.payment;
  }
}
